module.exports = __webpack_public_path__ + "img/16_45.1ba67317.png";